import { useState } from "react";
import { Dropdown, Menu, Button, Spin } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useItemsFine } from "../../_actions/app/items";

function FontPicker({ onChange }) {
    const [selectedFont, setSelectedFont] = useState("");

    // Fetch fonts from backend
    const {
        data: FontsData,
        isLoadingData,
    } = useItemsFine("qdb_fonts", "fields=id,name");

    const handleFontSelect = (fontName) => {
        setSelectedFont(fontName);
        if (onChange) {
            onChange(fontName);
        }
    };

    if (isLoadingData) {
        return <Spin />;
    }

    return (
        <>
            {/* Load Google Fonts dynamically */}
            {FontsData?.length > 0 &&
                FontsData.map((font) => (
                    <link
                        key={font.id}
                        href={`https://fonts.googleapis.com/css2?family=${font.name.replace(
                            /\s+/g,
                            "+"
                        )}&display=swap`}
                        rel="stylesheet"
                        crossOrigin="anonymous"
                    />
                ))}

            {/* Dropdown UI */}
            <Dropdown
                overlay={
                    <Menu
                        onClick={(e) => {
                            const font = FontsData?.find((f) => f.id === e.key);
                            if (font) {
                                handleFontSelect(font.name);
                            }
                        }}
                    >
                        {FontsData?.map((font) => (
                            <Menu.Item key={font.id}>
                                <span style={{ fontFamily: font.name }}>
                                    {font.name}
                                </span>
                            </Menu.Item>
                        ))}
                    </Menu>
                }
                trigger={["click"]}
            >
                <Button>
                    {selectedFont ? (
                        <span style={{ fontFamily: selectedFont }}>
                            {selectedFont}
                        </span>
                    ) : (
                        "Choose Font"
                    )}{" "}
                    <DownOutlined />
                </Button>
            </Dropdown>
        </>
    );
}

export default FontPicker;
